/**
 * Pre-compiled localized messages for LoadingSpinner component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import loadingSpinnerMessages_en from "./intl/en";
import loadingSpinnerMessages_de from "./intl/de";
import loadingSpinnerMessages_es from "./intl/es";
import loadingSpinnerMessages_fr from "./intl/fr-FR";
import loadingSpinnerMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const loadingSpinnerMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(loadingSpinnerMessages_en),
  de: normalizeMessages(loadingSpinnerMessages_de),
  es: normalizeMessages(loadingSpinnerMessages_es),
  "fr-FR": normalizeMessages(loadingSpinnerMessages_fr),
  "pt-BR": normalizeMessages(loadingSpinnerMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for LoadingSpinner component
 */
export type LoadingSpinnerMessageKey = "default";
